export function parseCommaSeparatedIds(value: string): number[] {
    if (!value) return [];
    return value
        .split(",")
        .map((s) => parseInt(s.trim(), 10))
        .filter((n) => !isNaN(n));
}
